import React from 'react'
import BacktestReportCard from './BacktestReportCard'
import { useApplicationSuiteContext } from '../../contexts/ApplicationSuiteProvider'

type SessionInfo = {
  sessionId: string
  count: number
  backtestIds: string[]
}

type SessionAlbumCardProps = {
  cover: any
  sessionInfo: SessionInfo
  condensed?: boolean
  isActive?: boolean
  onBacktestSelection?: (backtest: any) => void
}

function SessionAlbumCard({
  cover,
  sessionInfo,
  condensed,
  isActive,
  onBacktestSelection,
}: SessionAlbumCardProps) {
  const { usermeta } = useApplicationSuiteContext()

  const footerActions: any[] = [
    {
      type: 'OPEN_SETTINGS',
      onSettingsClick: (open: boolean) => onBacktestSelection?.(open ? cover : null),
    },
  ]

  if (usermeta?.isAdmin) {
    footerActions.push({ type: 'RUN_AGENT_SESSION' })
  }

  return (
    <BacktestReportCard
      backtest={cover}
      condensed={condensed}
      isActive={isActive}
      footerActions={footerActions}
    />
  )
}

export default SessionAlbumCard
